<div class=" mt-4" >
  <section class="my-4">
    <div class="scrollmenu"> 
      <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a>
      <a   class="active menu"  [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a>
    </div>
  </section>
  <section>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <!-- <a href="" class="back-tour mr-3" type="a" data-toggle="modal" data-target="#exampleModalCenter">Need Help ?
            Take a Tour <i class="far fa-lightbulb"></i></a> -->
          <!-- <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-toggle="dropdown">Export as &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a href="" id="btnExportBatch" (click)="readAndExportToExcelData()">Excel</a></li>

            </ul>
          </div> -->
     
          <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"><i class="fa fa-filter" aria-hidden="true"></i> Filter</button>

        </div>

      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click
          onFilter</small>
      </div>
    </div>
    <div class="col-md-12 my-3" *ngIf="filtering">
      <div class="card-1 p-4">
        <div class="row">
          <div class="col-md-3 mt-3">
           
            <div class="form-group">
              <label class="customlabel"> Date</label>
              <div class="selectcustom mb-0">
                <ngx-select [items]="Range" id="daterange" placeholder="DateRange" [formControl]="daterange"
                (ngModelChange)="checkRangeType()" required>
                <!-- (ngModelChange)="selectedaterange()" required> -->
              </ngx-select>
              </div>
             
            </div>
          </div>
          <div class="col-md-3 mt-3" *ngIf="Rfromdate"> 
            <div class="form-group">
              <label class="customlabel">From Date</label>
              <input type="date" class="formcontrol-user1 form-control" placeholder="From Date" id="fromdate" [formControl]="fromdate"
                (change)="checkDateRange()">
            </div>
          </div>

          <div class="col-md-3 mt-3" *ngIf="Rfromdate">
            <div class="form-group">
              <label class="customlabel"> To Date</label>
              <input type="date" class="formcontrol-user1 form-control" placeholder="To Date" id="todate" [formControl]="todate"
               (change)="checkDateRange()">
            </div>
            <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To Date</span>
          </div>
          <!-- <div class="col-md-3 mt-3">
            <div class="form-group">
              <label class="customlabel">Merchant KeyId</label>
              <input type="text" class="formcontrol-user1 form-control" placeholder="MerchantKey Id" id="merchantKeyId"
                [formControl]="merchantKeyId">
            </div>
          </div> -->
          <div class="col-md-3 mt-3">
            <div class="form-group">
              <label class="customlabel">Transaction ID</label>
              <input type="text" class="formcontrol-user1 form-control" placeholder="Transaction Id" id="TransactionId"
                [formControl]="TransactionId">
            </div>
          </div>

          <div class="col-md-3 mt-3">
            <div class="form-group">
              <label class="customlabel">IFSCCode</label>
              <input type="text" class="formcontrol-user1 form-control" placeholder="IFSCCode" id="IFSCCode" [formControl]="IFSCCode">
            </div>
          </div>
          <!-- <div class="col-md-3 mt-3">
            <div class="form-group">
              <label class="customlabel">Mobile Number</label>
              <input type="text" class="formcontrol-user1 form-control" placeholder="Mobile Number" id="MobileNumber" [formControl]="MobileNumber">
            </div>
          </div> -->


          <div class="col-md-3 mt-3">
            <div class="form-group">
              <label class="customlabel">Account Number</label>
              <input type="text" class="formcontrol-user1 form-control" placeholder="Account Number" id="AccountNumber" [formControl]="AccountNumber">
            </div>
          </div>
          <div class="col text-right mt-3" *ngIf="!isCustomDateSelected">
            <button class="btn dash-btns " type="button" id="filtering" (click)="selectedaterange()"
              matTooltip="New Sale Transaction"> Search</button>
          </div>


          <div class="col text-right mt-3" *ngIf="isCustomDateSelected">
            <button class="btn dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive"
              (click)="search()" matTooltip="New Sale Transaction"> Search</button>
          </div>


        </div>
      </div>
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="TransactionRows">
          <ngx-datatable-column name="Action">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a href=""  class="back-tour mr-3" type="a" (click)="ResendEmail(row)" *ngIf="row.ResponseCode!=1 && row.ResponseCode!=2 ">
               Resend Email
              </a>
              <a href="" class="back-tour mr-3" type="a" (click)="ResendSms(row)"
              *ngIf="row.ResponseCode!=1 && row.ResponseCode!=2 ">
             Resend SMS
            </a>

            </ng-template>
          </ngx-datatable-column>
         

         
          <ngx-datatable-column name="Transaction Id" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> 
              <a class=" edit" [routerLink]="['/PayOut/ViewPayOutTransactions',{Id: row.TransactionId}]" data-toggle="tooltip"
              data-placement="top" title="View">

              {{row.TransactionId}}
              </a>
            </ng-template>
          </ngx-datatable-column>
       
      
          <ngx-datatable-column name="MobileNumber" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.MobileNumber}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Email" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.Email}}
            </ng-template>
          </ngx-datatable-column>
        

          <ngx-datatable-column name="Response Text">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.ResponseText}} </ng-template>
          </ngx-datatable-column>
  

          <ngx-datatable-column name="Beneficiary Name">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BeneficiaryName}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="BankName">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BankName}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Account Number">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountNumber}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="IFSC Code">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.IFSCCode}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Updated Datetime">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDateTime| date:'d/M/yy, h:mm a'}}</div>
            </ng-template>
          </ngx-datatable-column>




        </ngx-datatable>
      </div>
    </div>
  </section>
</div>

